export const courseComponents = {
  '-26': 'ThreeLessonView',
  '-25': 'LiteracyCourseView',
  '-24': 'SpecialCourseView',
  '-23': 'SyncCourse',
  '-1600': 'LiteracyCourseView',
  '2242': 'ThreeLessonView' 
}




// WEBPACK FOOTER //
// ./src/defines/courseComponents.js